import { useApolloClient } from '@apollo/client'
import { useSnackbar } from 'notistack'
import React from 'react'
import { useDoctorCard } from '../../component/AppLayout/useDoctorCard'
import { AccountMainForm } from '../../component/Config/Profile/MainForm'
import ProfileLayout from '../../component/Config/Profile/ProfileLayout'
import { useProfileStyles } from '../../component/Config/Profile/styles'
import { TabPanel } from '../../component/Config/Profile/TabPanel'
import { FETCH_CARD, UPDATE_WORKSPACE } from '../../graphql/queries'
import { useWorkspace, Workspace } from '../../providers/workspace'

export const Profile = (): JSX.Element => {
  const classes = useProfileStyles()
  const { selectedWorkspace } = useWorkspace(({ selectedWorkspace }) => ({
    selectedWorkspace
  }))
  const [editingWorkspace, setEditingWorkspace] = React.useState<Workspace>()
  const [loading, setLoading] = React.useState(false)
  const apolloClient = useApolloClient()
  const { enqueueSnackbar } = useSnackbar()
  const { loadDoctorCard } = useDoctorCard()

  React.useEffect(() => {
    if (!selectedWorkspace) return
    apolloClient.query({ query: FETCH_CARD }).then(({ data }) => {
      setEditingWorkspace(data.currentWorkspace)
    })
  }, [selectedWorkspace])

  const handleUpdateWorkspace = (newWorkspace: Workspace) => {
    if (!newWorkspace) return
    setLoading(true)
    apolloClient
      .mutate({
        mutation: UPDATE_WORKSPACE,
        variables: { input: newWorkspace }
      })
      .then(({ data }) => {
        loadDoctorCard(apolloClient)
        enqueueSnackbar(data.updateAccountWorkspace.message, {
          variant: 'success',
          autoHideDuration: 2000
        })
      })
      .finally(() => setLoading(false))
  }

  return (
    <ProfileLayout>
      <TabPanel value={0} index={0}>
        <h1 className={classes.title}>Editar Perfil</h1>
        {editingWorkspace && (
          <AccountMainForm
            loading={loading}
            onSave={handleUpdateWorkspace}
            editingWorkspace={editingWorkspace}
          />
        )}
      </TabPanel>
    </ProfileLayout>
  )
}
